export default __webpack_public_path__ + "static/media/1_tesipro.88c46745.svg";